import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";

const SEGMENTS = [
  { key: "approvedStores", label: "Approved", color: "var(--dashboard-success)" },
  { key: "pendingStores", label: "Pending", color: "var(--dashboard-warning)" },
  { key: "rejectedStores", label: "Rejected", color: "var(--dashboard-danger)" },
];

const StoreStatusPieChart = ({ counts = {} }) => {
  const data = SEGMENTS.map((s) => ({
    ...s,
    value: Number(counts?.[s.key] ?? 0),
  }));
  const total = data.reduce((sum, d) => sum + d.value, 0);

  return (
    <div className="flex flex-col items-center">
      <PieChart width={180} height={180}>
        <Pie
          data={data}
          dataKey="value"
          nameKey="label"
          cx="50%"
          cy="50%"
          innerRadius={55}
          outerRadius={80}
          startAngle={90}
          endAngle={-270}
        >
          {data.map((entry) => (
            <Cell key={entry.key} fill={entry.color} />
          ))}
        </Pie>
        <text
          x="50%"
          y="48%"
          textAnchor="middle"
          fontSize="22px"
          fontWeight="bold"
          fill="var(--dashboard-gray-900)"
        >
          {total}
        </text>
        <text
          x="50%"
          y="63%"
          textAnchor="middle"
          fontSize="11px"
          fill="var(--dashboard-gray-500)"
        >
          Total Stores
        </text>
        <Tooltip />
      </PieChart>
      <div className="mt-3 w-full flex flex-col gap-2">
        {data.map((d) => (
          <div
            key={d.key}
            className="flex items-center justify-between text-[13px]"
          >
            <div className="flex items-center gap-2">
              <span
                className="inline-block w-2.5 h-2.5 rounded-full"
                style={{ background: d.color }}
              />
              <span className="text-[var(--dashboard-gray-600)]">{d.label}</span>
            </div>
            <span className="text-[var(--dashboard-gray-400)]">{d.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StoreStatusPieChart;
